import React, { useState } from 'react';

const EmojiPicker = ({ onSelect, currentEmoji }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  
  const emojiCategories = {
    all: {
      name: 'Alle',
      icon: '🎯',
      emojis: [
        // Bildung & Lernen
        '📚', '📖', '📝', '📊', '📈', '🎓', '📋', '📌', '💡', '🧠',
        // Business & Arbeit
        '💼', '🎯', '🏆', '⭐', '🔥', '💪', '🏅', '🚀', '💰', '💎',
        // Technologie
        '📱', '💻', '🖥️', '⌨️', '🖱️', '🔧', '⚙️', '🔌', '💾', '📡',
        // Kommunikation
        '📞', '📩', '📧', '💬', '🗣️', '📢', '📻', '🎙️', '📺', '🎧',
        // Menschen & Teams
        '👥', '🤝', '👤', '👨‍💼', '👩‍💼', '🎭', '🎪', '🎨', '🎬', '🎤',
        // Verkauf & Marketing
        '🛒', '🛍️', '💳', '📦', '🏷️', '🎁', '📈', '📊', '💹', '🎯',
        // Transport & Logistik
        '🚗', '🚚', '✈️', '🚢', '🚂', '🚲', '📍', '🗺️', '📱', '🔍'
      ]
    },
    business: {
      name: 'Business',
      icon: '💼',
      emojis: ['💼', '🎯', '🏆', '⭐', '🔥', '💪', '🏅', '🚀', '💰', '💎', '📊', '📈', '💹', '🎁', '🏷️']
    },
    education: {
      name: 'Bildung',
      icon: '📚',
      emojis: ['📚', '📖', '📝', '🎓', '📋', '📌', '💡', '🧠', '✏️', '📏', '🖊️', '🖍️', '📐', '🧮', '🎒']
    },
    technology: {
      name: 'Technik',
      icon: '💻',
      emojis: ['💻', '📱', '🖥️', '⌨️', '🖱️', '🔧', '⚙️', '🔌', '💾', '📡', '🔋', '📹', '📷', '🎮', '🕹️']
    },
    communication: {
      name: 'Kommunikation',
      icon: '📞',
      emojis: ['📞', '📩', '📧', '💬', '🗣️', '📢', '📻', '🎙️', '📺', '🎧', '📨', '📪', '📫', '📬', '📭']
    },
    people: {
      name: 'Menschen',
      icon: '👥',
      emojis: ['👥', '🤝', '👤', '👨‍💼', '👩‍💼', '🎭', '🎪', '🎨', '🎬', '🎤', '👨‍🎓', '👩‍🎓', '👨‍🏫', '👩‍🏫', '👨‍⚕️']
    },
    symbols: {
      name: 'Symbole',
      icon: '⚡',
      emojis: ['✅', '❌', '⚠️', '💯', '🔔', '📢', '🔑', '🎪', '🎯', '⚡', '🌟', '💫', '✨', '🔮', '🎲']
    }
  };

  const filteredEmojis = activeCategory === 'all' 
    ? emojiCategories.all.emojis.filter(emoji => 
        searchTerm === '' || emoji.includes(searchTerm)
      )
    : emojiCategories[activeCategory].emojis.filter(emoji => 
        searchTerm === '' || emoji.includes(searchTerm)
      );

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-3 px-4 py-3 border-2 border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white hover:bg-gray-50 transition-all duration-200 shadow-sm hover:shadow-md min-w-[160px]"
      >
        <span className="text-3xl">{currentEmoji || '🎯'}</span>
        <div className="flex flex-col items-start">
          <span className="text-sm font-semibold text-gray-700">Icon wählen</span>
          <span className="text-xs text-gray-500">Klicken für Auswahl</span>
        </div>
        <svg className="w-4 h-4 text-gray-400 ml-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      
      {isOpen && (
        <div className="absolute top-full right-0 mt-2 bg-white border border-gray-200 rounded-2xl shadow-2xl p-6 z-50 w-96">
          {/* Header */}
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-bold text-gray-800">Icon auswählen</h3>
            <button
              type="button"
              onClick={() => setIsOpen(false)}
              className="text-gray-400 hover:text-gray-600 p-1 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Search */}
          <div className="mb-4">
            <div className="relative">
              <svg className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <input
                type="text"
                placeholder="Icons durchsuchen..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
              />
            </div>
          </div>

          {/* Category Tabs */}
          <div className="mb-4">
            <div className="flex flex-wrap gap-2">
              {Object.entries(emojiCategories).map(([key, category]) => (
                <button
                  key={key}
                  type="button"
                  onClick={() => setActiveCategory(key)}
                  className={`flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-medium transition-all duration-200 ${
                    activeCategory === key
                      ? 'bg-blue-500 text-white shadow-md'
                      : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
                >
                  <span className="text-lg">{category.icon}</span>
                  <span>{category.name}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Emoji Grid */}
          <div className="mb-4">
            <div className="grid grid-cols-8 gap-2 max-h-64 overflow-y-auto p-2 bg-gray-50 rounded-xl">
              {filteredEmojis.map((emoji, index) => (
                <button
                  key={index}
                  type="button"
                  onClick={() => {
                    onSelect(emoji);
                    setIsOpen(false);
                    setSearchTerm('');
                  }}
                  className="group text-3xl p-3 hover:bg-white rounded-xl transition-all duration-150 shadow-sm hover:shadow-md border border-transparent hover:border-blue-200 flex items-center justify-center min-h-[56px]"
                  title={`Icon wählen: ${emoji}`}
                >
                  <span className="select-none">{emoji}</span>
                </button>
              ))}
            </div>
            {filteredEmojis.length === 0 && (
              <div className="text-center py-8 text-gray-500">
                <span className="text-2xl mb-2 block">🔍</span>
                <p className="text-sm">Keine Icons gefunden</p>
              </div>
            )}
          </div>

          {/* Manual Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Eigenes Icon eingeben:</label>
            <div className="flex gap-2">
              <input
                type="text"
                placeholder="z.B. 🚀 oder eigenes Emoji"
                onChange={(e) => {
                  if (e.target.value) {
                    onSelect(e.target.value);
                  }
                }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter' && e.target.value) {
                    setIsOpen(false);
                    setSearchTerm('');
                  }
                }}
                className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                maxLength="3"
              />
              <button
                type="button"
                onClick={() => {
                  setIsOpen(false);
                  setSearchTerm('');
                }}
                className="px-4 py-2 bg-blue-500 text-white rounded-xl hover:bg-blue-600 transition-colors text-sm font-medium"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmojiPicker;
